module.exports = __webpack_public_path__ + "static/media/basel-45.90abf361.jpg";